var LocalStorageUtils = /** @class */ (function () {
    function LocalStorageUtils() {
    }
    LocalStorageUtils.setItem = function (key, value, expiry) {
        var item = {
            value: value,
            timestamp: new Date().getTime(),
            expiry: expiry
        };
        try {
            localStorage.setItem(key, JSON.stringify(item));
        }
        catch (e) {
            console.error('LocalStorage setItem error:', e);
        }
    };
    LocalStorageUtils.getItem = function (key) {
        try {
            var item = localStorage.getItem(key);
            if (!item)
                return null;
            var parsedItem = JSON.parse(item);
            // Check if item has expired
            if (parsedItem.expiry && new Date().getTime() - parsedItem.timestamp > parsedItem.expiry) {
                this.removeItem(key);
                return null;
            }
            return parsedItem.value;
        }
        catch (e) {
            console.error('LocalStorage getItem error:', e);
            return null;
        }
    };
    LocalStorageUtils.removeItem = function (key) {
        try {
            localStorage.removeItem(key);
        }
        catch (e) {
            console.error('LocalStorage removeItem error:', e);
        }
    };
    LocalStorageUtils.clear = function () {
        try {
            localStorage.clear();
        }
        catch (e) {
            console.error('LocalStorage clear error:', e);
        }
    };
    return LocalStorageUtils;
}());
export default LocalStorageUtils;
